/* eslint-disable */
import React, { Component } from "react";

import logo from "./logo.svg";

import DirectorImage from "./assets/images/HO_Sharma.jpg";
import logoDigitalIndia from "./assets/images/logo-digital-india.png";
import makeInIndiaLogo from "./assets/images/logo-make-in-india.png";
import swatchhBharatLogo from "./assets/images/logo-swach-bharat-abhiyan.png";

import img_1 from "./assets/images/Photo for Website zip/img_1.JPG";
import img_2 from "./assets/images/Photo for Website zip/img_2.JPG";
import img_3 from "./assets/images/Photo for Website zip/img_3.JPG";
import img_4 from "./assets/images/Photo for Website zip/img_4.JPG";
import img_5 from "./assets/images/Photo for Website zip/img_5.JPG";
import img_6 from "./assets/images/Photo for Website zip/img_6.JPG";
import img_7 from "./assets/images/Photo for Website zip/img_7.JPG";
import img_8 from "./assets/images/Photo for Website zip/img_8.JPG";
import img_9 from "./assets/images/Photo for Website zip/img_9.JPG";
import img_10 from "./assets/images/Photo for Website zip/img_10.JPG";
import img_11 from "./assets/images/Photo for Website zip/img_11.JPG";
import img_12 from "./assets/images/Photo for Website zip/img_12.JPG";
import img_13 from "./assets/images/Photo for Website zip/img_13.JPG";
import img_14 from "./assets/images/Photo for Website zip/img_14.JPG";
import img_15 from "./assets/images/Photo for Website zip/img_15.JPG";
import img_16 from "./assets/images/Photo for Website zip/img_16.JPG";
import img_17 from "./assets/images/Photo for Website zip/img_17.JPG";
import img_18 from "./assets/images/Photo for Website zip/img_18.JPG";
import img_19 from "./assets/images/Photo for Website zip/img_19.JPG";
import img_20 from "./assets/images/Photo for Website zip/img_20.JPG";
import img_21 from "./assets/images/Photo for Website zip/img_21.JPG";
import img_22 from "./assets/images/Photo for Website zip/img_22.JPG";
import img_23 from "./assets/images/Photo for Website zip/img_23.JPG";
import img_24 from "./assets/images/Photo for Website zip/img_24.JPG";
import img_25 from "./assets/images/Photo for Website zip/img_25.JPG";
import img_26 from "./assets/images/Photo for Website zip/img_26.JPG";
import img_27 from "./assets/images/Photo for Website zip/img_27.JPG";
import img_28 from "./assets/images/Photo for Website zip/img_28.JPG";
import img_29 from "./assets/images/Photo for Website zip/img_29.JPG";
import img_30 from "./assets/images/Photo for Website zip/img_30.JPG";
import img_31 from "./assets/images/Photo for Website zip/img_31.JPG";
import img_32 from "./assets/images/Photo for Website zip/img_32.JPG";
import img_33 from "./assets/images/Photo for Website zip/img_33.JPG";
import img_34 from "./assets/images/Photo for Website zip/img_34.JPG";

import Header from "./components/header";
import Footer from "./components/footer";
import "./assets/js/niceselect";
import { faRoad } from "@fortawesome/free-solid-svg-icons";

function App() {
  return (
    <div className="container">
      <section id="hero-area" className="  hero-area overlay">
        {/* <!-- Slider Area --> */}

        <div class="slider-active">
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_14})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_2})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_3})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_4})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_5})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_6})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_7})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_8})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_9})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_10})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_11})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_12})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_13})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_1})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_15})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_16})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_17})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_18})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_19})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_20})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_21})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_22})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_23})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_24})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_25})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_26})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_27})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_28})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_29})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_30})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_31})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_32})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_33})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="single-slider overlay"
            style={{ backgroundImage: `url(${img_34})` }}
          >
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="hero-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--/ End Hero Area Slider --> */}

      {/* <!-- Why Choose --> */}
      <section id="why-choose" class="why-choose section">
        <div class="container">
          <div class="row">
            <div class="col-12 wow zoomIn" data-wow-delay="0.4s">
              <div class="title-line center">
                <h2>
                  <span> Welcome To </span> AERC
                </h2>
                <p>
                  Way back in 1952 i.e., almost with the inception of planning
                  in India, the idea was mooted to establish Agro-Economic
                  Research Centre for each state to serve as the catalyst of
                  region specific agricultural transformation. It was one of the
                  earliest institutional efforts to propagate and interweave
                  knowledge based farming to a specific region. The year 1954
                  was a landmark in the history of agricultural economics in
                  India as in that year the Ministry of Food and Agriculture,
                  Government of India, established 4 Agro- Economic Research
                  Centres at Delhi, Pune, Chennai and Santiniketan. 2 more
                  centres were established in 1958, one at Jorhat (Assam) and
                  another at Sehore (Madhya Pradesh). In 1961 one more Agro
                  Economic Research Centre was established at
                  VallabhVidyaNagar.In the later years three more centres were
                  established at Allahabad, Waltair and Shimla bringing the
                  total number of centres in the country to 10. In 1966 two more
                  centres were established at ..... Read More
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Why Choose --> */}

      {/* <!-- Testimonials --> */}
      <section
        id="testimonials"
        class="testimonials overlay section wow fadeInUp"
        data-wow-delay="0.4s"
        data-stellar-background-ratio="0.5"
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="testimonial-slider-two">
                {/* <!-- Single Slider --> */}
                <div class="single-slider">
                  <div class="author">
                    {" "}
                    <img src={DirectorImage} alt="#" />
                    <h2>
                      <i class="icofont-quote-left"></i>Director Message
                      <i class="icofont-quote-right"></i>{" "}
                    </h2>
                  </div>
                  <div class="t-content">
                    <p>
                      The Agro-Economic Research Centre for the States of Madhya
                      Pradesh and Chhattisgarh was established at the Jawaharlal
                      Nehru Krishi Vishwa Vidyalaya, Jabalpur (M.P.) in 1st
                      April 1965 at by the Directorate of Economics and
                      Statistics, ..... Read More
                    </p>
                  </div>
                </div>

                <div class="single-slider">
                  <div class="author">
                    {" "}
                    <img src={DirectorImage} alt="#" />
                    <h2>
                      <i class="icofont-quote-left"></i>Director Message
                      <i class="icofont-quote-right"></i>{" "}
                    </h2>
                  </div>
                  <div class="t-content">
                    <p>
                      {" "}
                      The Agro-Economic Research Centre for the States of Madhya
                      Pradesh and Chhattisgarh was established at the Jawaharlal
                      Nehru Krishi Vishwa Vidyalaya, Jabalpur (M.P.) in 1st
                      April 1965 at by the Directorate of Economics and
                      Statistics, Read more...{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
